import { InertiaLinkProps } from '@inertiajs/react';
import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

export function isSameUrl(
    url1: NonNullable<InertiaLinkProps['href']>,
    url2: NonNullable<InertiaLinkProps['href']>,
) {
    return resolveUrl(url1) === resolveUrl(url2);
}

export function resolveUrl(url: NonNullable<InertiaLinkProps['href']>): string {
    return typeof url === 'string' ? url : url.url;
}

export const applyRootPath = (url: string) => {
    // @ts-ignore
    const rootPath = window.__ROOT_PATH__ || '/';

    if (url.startsWith('/') && !url.startsWith(rootPath)) {
        const normalizedRootPath = rootPath.endsWith('/') ? rootPath : rootPath + '/';
        const normalizedUrl = url.startsWith('/') ? url.substring(1) : url;
        return normalizedRootPath + normalizedUrl;
    }

    return url;
};
